export default "shared/tippy.e012f5144451ed83.css"